module.exports = __webpack_public_path__ + "img/GQ.b08142fc.png";